module.exports = __webpack_public_path__ + "static/media/ambrussum_pontamroix_tn.788de82e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/ambrussum_pontamroix_tn.jpg
// module id = 698
// module chunks = 0